import { formBuilderData } from "src/app/helper/interface/response";

export const ADD_APPOINTMENT: formBuilderData[] = [
    {
        colName: 'patient_fk_id',
        title: 'Patient',
        type: 'AUTOCOMPLETE',
        apiTblName: 'patient',
        selectKeyName: 'patientName',
        selectPrimaryKey: 'id',
        apiFunName: 'search',
        autoSearch: {
            titleKey: 'patientName',
            selectFieldKeys: ['patientName', 'patient_id', 'mobile_no']
        },
        validator: [{ name: 'required' }],
        forceSelection: false,

        allowFreeText: true,
        freeTextField: 'patientName'
    },
    {
        colName: 'doctor_fk_id',
        title: 'Doctor Name',
        type: 'select',
        apiTblName: 'doctor',
        selectKeyName: 'fname',
        selectPrimaryKey: 'user_id',
        event: { name: 'change', isCallback: true },
        validator: [{ name: 'required' }],
        col_size: 6
    },
    {
        colName: 'treatment_fk_id',
        title: 'Treatment ',
        placeholder: 'Add Treatment',
        type: 'select',
        apiTblName: 'treatment',
        selectKeyName: 'treatmentName',
        selectPrimaryKey: 'id',
        col_size: 6,
        event: { name: 'change', isCallback: true },
    },
    {
        colName: 'appointment_on',
        title: 'Appointment Date & Time',
        type: 'DATETIME',
        showTime: true,
        stepMinute: 10,
        timeOnly: false,
        monthNavigator: true,
        validator: [{ name: 'required' }]
    },
    {
        colName: 'mobile_no',
        title: 'Mobile Number',
    },
    {
        colName: 'appointment_for',
        title: 'Notes ',
    },


];

export const APPOINTMENT_LIST: formBuilderData[] = [
    {
        colName: 'doctorName',
        title: 'Doctor Name'
    },
    {
        colName: 'appointment_on',
        title: 'Appointment On',
        colType: 'DATE'
    },
    {
        colName: 'appointment_for',
        title: 'Notes',
    },
    {
        colName: 'status',
        title: 'Status',
        colType: 'DROPDOWN',
        filterCol: {
            type: 'DROPDOWN',
            selectPrimaryKey: 'key',
            selectKeyName: 'label',
            data: [{ label: 'Visited', key: 1, color: 'info' }, { label: 'Active', key: 2, color: 'warning' }, { label: 'Pending', key: 3, color: 'warning' }, { label: 'Missed', key: 4, color: 'danger' }],
            //  selectKeyName: 'typeName',
        }
    },
    {
        colName: 'rescheduledStatusName',
        title: 'Is Reschedule',
    }
]
